export default "__VITE_ASSET__o_pjPkJe__"